<div class="w-full h-screen flex flex-col items-center justify-center">
  @if (missingToken()) {
    <div class="flex flex-col items-center justify-center">
      <h1 class="text-2xl font-bold text-white">Missing token</h1>
      <p class="text-gray-300 text-sm">No token provided</p>
    </div>
  } @else if (invalidToken()) {
    <div class="flex flex-col items-center justify-center">
      <h1 class="text-2xl font-bold text-white">Invalid token</h1>
      <p class="text-gray-300 text-sm">The token is invalid or expired</p>
    </div>
  } @else {
    <app-loading-spinner text="Verifying token" i18n-text />
  }
</div>
